import { Container, Sprite, Texture } from 'pixi.js';
import { HitboxDefinition, ObstacleHitboxes } from './config/HitboxConfig';

export class Obstacle extends Container {
  private sprite: Sprite;
  private obstacleWidth: number;
  private obstacleHeight: number;
  private hitboxConfig: HitboxDefinition;

  constructor(x: number, y: number, texture: Texture, obstacleType: string, scale: number = 0.5) {
    super();

    this.sprite = new Sprite(texture);
    this.sprite.anchor.set(0.5, 1);
    this.sprite.scale.set(scale);

    this.obstacleWidth = this.sprite.width;
    this.obstacleHeight = this.sprite.height;
    this.hitboxConfig = ObstacleHitboxes[obstacleType] || {
      offsetX: 0.1,
      offsetY: 0.1,
      width: 0.8,
      height: 0.8,
    };

    this.x = x;
    this.y = y + (this.hitboxConfig.verticalOffset || 0) * this.obstacleHeight;

    this.addChild(this.sprite);
  }

  update(scrollSpeed: number, deltaTime: number): void {
    this.x -= scrollSpeed * deltaTime;
  }

  isOffScreen(): boolean {
    return this.x + this.obstacleWidth / 2 < 0;
  }

  getHitbox(): { x: number; y: number; width: number; height: number } {
    const hitboxWidth = this.obstacleWidth * this.hitboxConfig.width;
    const hitboxHeight = this.obstacleHeight * this.hitboxConfig.height;
    const hitboxOffsetX = this.obstacleWidth * this.hitboxConfig.offsetX;
    const hitboxOffsetY = this.obstacleHeight * this.hitboxConfig.offsetY;

    return {
      x: this.x - this.obstacleWidth / 2 + hitboxOffsetX,
      y: this.y - this.obstacleHeight + hitboxOffsetY,
      width: hitboxWidth,
      height: hitboxHeight,
    };
  }
}
